/*****************************************************************************************************************************************************
 * Revision History
 * 2024-08-302 TBH - Added getCanGradeTooltip() method.
 *****************************************************************************************************************************************************/
export default function instructorCourseMaintenance() {
    // console.log( 'instructorCourseMaintenance' );
    return {
        rosterList: [],
        payDates: [],
        showErrorMesage: false,
        currentDate: '',                  
        gradingDate: new Date().getDate(),
        showLoader:false,
        formatDate(dateValue) {
            const options = { month: 'short', day: 'numeric', year:'numeric' };
            const formattedDate = new Date(dateValue).toLocaleDateString(undefined, options);
            return formattedDate;
        },
        formatContractDate(dateValue) {
            const date = new Date(dateValue);
            const month = date.getMonth() + 1; // Month is zero-based, so add 1
            const day = date.getDate();
            const year = date.getFullYear();
            return `${month}/${day}/${year}`;
        },
        formatEndDate(dateValue) {
            const options = { month: 'short', day: 'numeric', year: 'numeric' };
            const formattedDate = new Date(dateValue).toLocaleDateString(undefined, options);
            return formattedDate;
        },

        getCurrentDateTime() {
            const now = new Date();
            const options = { month: 'short', day: 'numeric', year: 'numeric' };
            this.currentDate = now.toLocaleDateString(undefined, options);
        },

        formatEventId(eventId) {
            if (eventId != null) {
                return eventId.replace("_", " ");
            }
        },
        removeTimeContent(times) {
        // Regular expression to match and remove content within parentheses
        return times.replace(/\([^()]*12:00[ ]?[Aa][Mm][^()]*\)/g, '');
        },
        getClassNameByAllowGrade(item) {
// console.log( 'getClassNameByAllowGrade()' );
// console.log( JSON.stringify( item ));
            return item.canGrade ? "button secondary inline-block" : "button inline-block text-white duration-300 bg-mediumGrayAlt border-mediumGrayAlt cursor-not-allowed";
        },

        checkGradeTooltip( item ) {
// console.log( 'checkGradeTooltip()' );
// console.log( JSON.stringify( item ));
          const gradingStarts = new Date( item.gradingStarts ).toLocaleDateString( 'en-US' );
          const gradingEnds   = new Date( item.gradingEnds ).toLocaleDateString( 'en-US' );

          var tooltip;

          if( item.canGrade )
            tooltip = 'Grading started ' + gradingStarts + ', ends ' + gradingEnds;
          else if(( item.percentage < 100 )&&( item.academicSession != "ACCESS" )) 
            tooltip = 'Can not grade if not 100% responsible for course';
          else if( item.credits <= 0 )
            tooltip = 'No grade entry for courses with zero units';
          else if( item.gradingDate < item.gradingStarts )
            tooltip = 'Grading starts ' + gradingStarts + ', ends ' + gradingEnds;
          else
            tooltip = 'Grading ended ' + gradingEnds;

          tooltip += '.';

          return( tooltip );
          },
  
        checkGrade(item) {
// console.log( 'checkGrade()' );
// console.log( JSON.stringify( item ));
            if( item.canGrade ) { 
              var url = document.getElementById( "hdnGradesPageURL" ).value
                  .concat( "?serialId=", item.serialId, "&academicYear=", item.academicYear, "&academicTerm=", item.academicTerm );

// console.log( 'checkGrade: ' + url );

              return( window.location.href = url );
              }
            else {
              return false;
              }
        },
        bindRosterList() {
            this.showLoader = true;
            fetch('/api/Instructors/GetStudentRosters', { "method": "GET" })
                .then(response => {
                    if (response.ok) {
                        return response.json()
                    }
                }).then(response => {
                    this.showLoader = false;
                    if (response != undefined && response.isSuccess) {
                        this.rosterList = response.rosterList;
                      } 
                    else {
                        this.showErrorMesage = "An unknown error has occurred. Please try again later."
                      }
                });
        },

        bindContractsList() {
            fetch('/api/Instructors/GetContracts', { "method": "GET" })
                .then(response => {
                    if (response.ok) {
                        return response.json()
                    }
                }).then(response => {

                    if (response != undefined && response.isSuccess) {
                        this.payDates = response.payDates;

                    } else {
                        this.showErrorMesage = "An unknown error has occurred. Please try again later."
                    }

                });

        },
       
        init() {
            this.bindRosterList();
            this.bindContractsList();
// console.log( 'init:getCurrentDateTime() call.');
            this.getCurrentDateTime();  /* TODO: Change to getGradingDate() or just remove! */
        }
    }
}